export default __webpack_public_path__ + "e72835447f238104bc759c3a8a0e67a6.svg";